import { render, staticRenderFns } from "./balance-sheet.vue?vue&type=template&id=04dd01d0&"
import script from "./balance-sheet.vue?vue&type=script&lang=js&"
export * from "./balance-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports